import React from 'react'
import { NavigationStackScreenComponent } from 'react-navigation-stack'
import { CustomHeader } from '../../components/CustomHeader'
import { formatMessage } from '../../constants/strings/intl/intlHooks'
import { messages } from '../../constants/strings/messages'
import { Coordinator } from '../../navigation/coordinator/coordinator'
import styled from 'styled-components/native'
import { atlTheme } from '../../atlTheme'
import { icons } from '../../constants/searchAssets'
import { ATLTextInputField } from '../../components/form/ATLTextInputField'
import { useForm } from 'react-simple-hooks-forms/dist'
import { ATLButton, ButtonTypeEnum } from '@appsimples/atlantica-react-native'
import { loginButtonRadius } from '../../constants/dimensions'
import { usePromise } from '../../utils/hooks/usePromise'
import { changeUserName } from '../../services/main/changeUserName'
import { showSuccessSnackbar } from '../../components/snackbar/Snackbar'

const Container = styled.SafeAreaView`
  flex: 1;
`
const FormContainer = styled.View`
  margin-top: ${atlTheme.SpacingAtomic}px;
  border-bottom-start-radius: ${atlTheme.BorderRadiusCard}px;
  border-bottom-end-radius: ${atlTheme.BorderRadiusCard}px;
  background: ${atlTheme.ColorSurface};
  width: 100%;
`

const formName = 'ChangeName'

const formFields = {
  NAME: 'name',
}

export const ChangeNameScreen: NavigationStackScreenComponent = () => {
  const { Form, submit } = useForm({ formName })

  const onRequestSuccess = () => {
    showSuccessSnackbar(formatMessage(messages.profileScreen_changeName_success), 5000)
    Coordinator.goToProfile()
  }

  const { request: updateName } = usePromise(changeUserName, [], {
    onSuccess: onRequestSuccess,
  })

  const onSuccessSubmit = val => {
    updateName({ nickname: val[formFields.NAME] })
  }

  const onSubmit = async () => {
    await submit(onSuccessSubmit, () => {})
  }

  return (
    <Container>
      <FormContainer>
        <Form>
          <ATLTextInputField
            name={formFields.NAME}
            title={formatMessage(messages.profileScreen_changeName_nameLabel)}
            leftIcon={icons.profile}
            textInputBaseProps={{
              focusColor: atlTheme.ColorMediumContrast,
              leftIconColor: atlTheme.ColorBrand2Default,
            }}
          />
          <ATLButton
            verticalMargin={atlTheme.SpacingMarginal}
            type={ButtonTypeEnum.outlined}
            title={formatMessage(messages.profileScreen_changeName)}
            buttonBaseProps={{ textColorComplementary: atlTheme.ColorBrand1Default, borderRadius: loginButtonRadius }}
            onPress={onSubmit}
            horizontalMargin={atlTheme.SpacingWide + atlTheme.SpacingMarginal}
          />
        </Form>
      </FormContainer>
    </Container>
  )
}

ChangeNameScreen.navigationOptions = CustomHeader(formatMessage(messages.profileScreen_changeName), true, () =>
  Coordinator.goBack()
)
